import { Col, Row } from 'reactstrap';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';
import { useIntl } from 'react-intl';
import Input from 'src/componentes/input';
import ColaboradorLookup from 'src/lookups/colaborador';
import TipoDocumentoLookup from 'src/lookups/TipoDocumentoLookup';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import StatusDocumentoLookup from 'src/lookups/StatusDocumentoLookup';
import Checkbox from 'src/componentes/checkbox';
import PanelCollapse from 'src/componentes/panel-collapse';
import { STATUS_DOCUMENTO, AGING } from 'src/utils/constants';
import StatusGeralDocumentoLookup from 'src/lookups/StatusGeralDocumentoLookup';
import AgingLookup from 'src/lookups/aging';
import CustomFieldsSection from 'src/componentes/filtro/search-drawer/CustomFieldsSection';

const IDS_IGNORAR_SITUACAO_DOCUMENTO = [
  STATUS_DOCUMENTO.RASCUNHO,
  STATUS_DOCUMENTO.APROVADO,
  STATUS_DOCUMENTO.CONCLUIDO,
  STATUS_DOCUMENTO.PENDENTE_APROVACAO,
  STATUS_DOCUMENTO.REPROVADO,
  STATUS_DOCUMENTO.REPROVADO_AGUARDANDO_SUBMISSAO,
];

function GEDSearch({ model }) {
  const { terms: resources } = useAuth();
  const intl = useIntl();

  return (
    <>
      <PanelCollapse
        header={intl.formatMessage({ id: 'label.informacoesBasicas' })}
        open={true}
        ehAccordionDrawer={true}
      >
        <Row>
          <Col md={12}>
            <Input model={model.getModel('idIntegracao')} />
          </Col>
          <Col md={12}>
            <Input model={model.getModel('nome')} />
          </Col>
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi={true}
              model={{
                label: capitalizeFirstLetter(resources.areas),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.incluirAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
              className="mb-3"
            />
          </Col>
          <Col md={12}>
            <ColaboradorLookup
              clearable
              multi
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                value: model.getModel('responsaveis').value,
                requestChange: model.getModel('responsaveis').requestChange,
                errors: model.getModel('responsaveis').errors,
              }}
            />
          </Col>
          <Col md={12}>
            <TipoDocumentoLookup
              multi
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelTipoDocumento' })
                ),
                value: model.getModel('tipoDocumentos').value,
                requestChange: model.getModel('tipoDocumentos').requestChange,
                errors: model.getModel('tipoDocumentos').errors,
              }}
            />
          </Col>
          <Col md={12}>
            <StatusGeralDocumentoLookup
              multi
              model={{
                label: intl.formatMessage({ id: 'status' }),
                value: model.getModel('statusGeral').value,
                requestChange: model.getModel('statusGeral').requestChange,
                errors: model.getModel('statusGeral').errors,
              }}
            />
          </Col>
          <Col md={12}>
            <StatusDocumentoLookup
              multi
              clearable
              data={{ idsIgnorar: [3] }}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelProximaVersao' })
                ),
                value: model.getModel('status').value,
                requestChange: model.getModel('status').requestChange,
                errors: model.getModel('status').errors,
              }}
            />
          </Col>
          <Col md={12}>
            <StatusDocumentoLookup
              multi
              clearable
              data={{ idsIgnorar: IDS_IGNORAR_SITUACAO_DOCUMENTO }}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelSituacao' })
                ),
                value: model.getModel('situacaoDocumento').value,
                requestChange:
                  model.getModel('situacaoDocumento').requestChange,
                errors: model.getModel('situacaoDocumento').errors,
              }}
            />
          </Col>
          <Col md={12}>
            <AgingLookup
              multi
              clearable
              data={{ idsIgnorar: [AGING.VENCIDO] }}
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage({ id: 'labelPrazoParaVencimento' })
                ),
                value: model.getModel('prazoParaVencimento').value,
                requestChange: model.getModel('prazoParaVencimento')
                  .requestChange,
                errors: model.getModel('prazoParaVencimento').errors,
              }}
            />
          </Col>
        </Row>
      </PanelCollapse>
      <CustomFieldsSection model={model} intl={intl} />
    </>
  );
}

export default GEDSearch;
